var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.$t('call.decline'),"placement":"bottom"}},[_c('button',[_c('i',{staticClass:"fas fa-phone-slash",on:{"click":_vm.decline}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }